<ngx-datatable 
    [rows]="rows" 
    [columns]="columns" 
    rowHeight="auto" 
    columnMode="force"> 
</ngx-datatable>